import { ReactComponent as smallProfitIcon } from './icons/euro-symbol.svg'

const translations = {
  petrol: 'Petrol',
  currency: {
    title: 'EUR',
    short: '€',
  },
  volume: {
    title: 'Litres',
    short: 'ℓ',
  },
  margin: {
    title: 'Cent Per Litre',
    short: 'cpl',
  },
  distance: {
    title: 'kilometres',
    short: 'km',
  },
  price: {
    short: 'CPL',
  },
  cost: {
    short: 'cpl',
  },
  favourite: 'Favourite',
  ordinals: {
    one: 'st',
    two: 'nd',
    few: 'rd',
    many: 'th',
    zero: 'th',
    other: 'th',
  },
  widgets: {
    competitorPricing: {
      increaseCashAndCreditTogether: 'Increase cash and credit together',
      decreaseCashAndCreditTogether: 'Decrease cash and credit together',
      cashCreditDifference: 'Cash/credit difference',
      setDifference: 'Set difference',
      differenceValue: 'Diff. {{value}}',
    },
    performanceReport: {
      lastWeek: 'last week',
      last2Weeks: 'last 2 weeks',
      yAxisLabels: {
        volume: 'Fuel volume / l',
        margin: 'Margin / cpl',
        profit: 'Profit / €',
        number: 'Transactions',
      },
    },
    settings: {
      customerPortal: 'uk-ireland',
    },
    analytics: {
      stockAndDeliveries: 'Stock and deliveries',
      fuelInTankAtEndOfDay: 'Fuel in tank at end of day',
      deliveredDuringTheDay: 'Delivered during the day',
      valueOfFuelAtEndOfDay: 'Value of fuel at end of day',
      volumeSoldDuringTheDay: 'Volume sold during the day',
      deliveryLandedDuringTheDay: 'Delivery landed during the day',
      allFuelGrades: 'All fuel grades',
      displayTanks: 'Display tanks',
      displayFuelGrades: 'Display fuel grades',
      exportTanks: 'Export tanks data',
      exportTanksForGrade: 'Export {{grade}} tanks data',
      exportFuelGrades: 'Export fuel grades data',
      volumeUnit: 'litres',
      yAxisLabels: {
        total_volume: 'Total volume / l',
        retail_volume: 'Retail volume / l',
        bunkered_volume: 'Bunkered volume / l',
        consumer_volume: 'Consumer volume / l',
        fuel_card_volume: 'Fuel card volume / l',
        gross_margin: 'Gross margin / cpl',
        net_margin: 'Net margin / cpl',
        gross_sales: 'Gross sales / €',
        gross_profit: 'Gross profit / €',
        net_profit: 'Net profit / €',
        business_profit: 'Business profit / €',
        bunkering_commissions: 'Bunkering commissions / €',
        replacement_cost: 'Replacement cost / cpl',
        total_fees: 'Total fees / €',
        blended_cost_sold: 'Blended cost sold / €',
        transactions: 'Transactions',
        fill_up: 'Fill up / l',
        pole_price: 'Pole price / cpl',
      },
    },
    polePriceAudit: {
      logHeadersPriceChange: 'Price change\n(cpl)',
      statusMessages: {
        completed: 'Price change detected.',
      },
    },
  },
}

export { translations, smallProfitIcon }
